import { render, staticRenderFns } from "./EpicList.vue?vue&type=template&id=6b4a87e8&"
import script from "./EpicList.vue?vue&type=script&lang=js&"
export * from "./EpicList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports